import React from 'react'
import '../styles/ErrorStyle.css';
import Navbar from '../components/Navbar';
export default function Error() {
    return (
        <>
        <Navbar/>
        
            <div className='errorbody' >
                <div className='error' title="Error 404" >
                    Error 404
                </div>
            </div>
        </>
    )
}
